// Configuración de Cloudinary para la galería de ExpoGardenias.
// IMPORTANTE: reemplazar estos valores con los reales antes de publicar el sitio.
// - CLOUD_NAME: nombre de la cuenta de Cloudinary (visible en el dashboard).
// - UPLOAD_PRESET: "unsigned upload preset" configurado en Cloudinary
//   (Settings > Upload > Upload presets) con "Signing Mode: Unsigned"
//   para permitir subir archivos desde el navegador sin backend propio.
export const CLOUD_NAME = 'flbyr5s9'
export const UPLOAD_PRESET = 'ExpoGardenias2026'
